import { Dimensions, StyleSheet } from 'react-native';

import { landscapeAspectRatio } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
    image: {
        width: Dimensions.get('window').width,
        aspectRatio: landscapeAspectRatio,
    },
});

export default styles;
